var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-dialog',{ref:"baseDialog",attrs:{"title":_vm.$t('companyManage.remainAmountSee'),"showConfirm":false},on:{"cancel":_vm.cancel}},[_c('table-list',{attrs:{"isDefine":true,"showSort":false,"columns":_vm.columns,"defaultContent":_vm.defaultContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }